import {Navigate} from 'react-router-dom'

const NotFound = () => (
    <Navigate to="/" />
)

export default NotFound